module.exports = __webpack_public_path__ + "img/artillery-speed.4913aaa2.png";